import { jsx as a, jsxs as f, Fragment as h } from "react/jsx-runtime";
import { useTranslation as p } from "react-i18next";
import i from "classnames";
import g from "../Tooltip/index.js";
import _ from "../../icons/Plus.js";
import "react";
import v from "../../hooks/useViewport.js";
const N = "forma-ui__tags__root", x = "forma-ui__tags__small", I = "forma-ui__tags__item", w = "forma-ui__tags__active", b = "forma-ui__tags__add", t = {
  root: N,
  small: x,
  item: I,
  active: w,
  add: b
}, u = ({ items: r, size: e }) => /* @__PURE__ */ a(h, { children: r.map(({ color: m, backgroundColor: o, name: s, active: n, className: c, onClick: d }, l) => /* @__PURE__ */ a(
  "div",
  {
    className: i(t.item, t[e], n && t.active, c),
    style: { color: m, backgroundColor: o },
    onClick: d,
    tabIndex: 0,
    "data-tag-index": l,
    children: s
  },
  l
)) }), q = ({ items: r, className: e, noWrapper: m, size: o = "medium", onClickAdd: s }) => {
  const { t: n } = p(), c = v();
  if (!r)
    return null;
  if (m)
    return /* @__PURE__ */ a(u, { size: o, items: r });
  const d = c === "phone";
  return /* @__PURE__ */ f("div", { className: i(t.root, t[o], e), children: [
    /* @__PURE__ */ a(u, { size: o, items: r }),
    s && (d ? /* @__PURE__ */ a("div", { className: i(t.item, t[o], t.add), onClick: s, tabIndex: 0, children: /* @__PURE__ */ a(_, { className: t.addIcon, width: 16, height: 16 }) }) : /* @__PURE__ */ a(g, { control: /* @__PURE__ */ a("div", { className: i(t.item, t[o], t.add), onClick: s, tabIndex: 0, children: /* @__PURE__ */ a(_, { className: t.addIcon, width: 16, height: 16 }) }), children: n("uikit:add") }))
  ] });
};
export {
  q as default
};
